import { useCallback, useEffect, useState } from "react";
import {
  fetchSurfCredits,
  formatCreditsBalance,
  type SurfAccountCredits,
} from "@vida/surf-core";
import { getAdminApiBaseUrl } from "../services/surfAdminApi";
import { ensureSurfClientConfig } from "../services/surfClientConfig";
import { getIdToken } from "../auth";

/** Saldo crediti per topbar/sidebar — una sola richiesta, niente usage breakdown. */
export function useSurfCreditsBalance() {
  const [credits, setCredits] = useState<SurfAccountCredits | null>(null);
  const [loading, setLoading] = useState(false);
  const [unavailable, setUnavailable] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      await ensureSurfClientConfig();
      const base = getAdminApiBaseUrl();
      if (!base) {
        setCredits(null);
        setUnavailable(true);
        return;
      }
      const next = await fetchSurfCredits({ adminApiBaseUrl: base, getIdToken });
      setCredits(next);
      setUnavailable(false);
    } catch (e) {
      setCredits(null);
      const msg = e instanceof Error ? e.message : String(e);
      setUnavailable(msg.includes("401") || msg.includes("Unauthorized"));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const balanceLabel = unavailable
    ? "—"
    : credits
      ? formatCreditsBalance(credits.balanceCents)
      : loading
        ? "…"
        : "—";

  return { credits, balanceLabel, loading, unavailable, refresh };
}
